import { isPrerender } from "@faire/web--source/common/user-agent/isPrerender";
import React, { lazy, Suspense } from "react";

export interface IDropdownsProps {
  selectedLinkName: string | undefined;
  onClick: () => void;
}

const LazyImpl = lazy(() =>
  import(
    /* webpackChunkName: "header-categories-dropdown" */ "@faire/retailer-visitor-shared/components/Header/desktop/NavigationLinksBar/__internal__/Dropdown/Dropdowns"
  ).then((m) => ({ default: m.Dropdowns }))
);

export const LazyDropdowns: React.FC<IDropdownsProps> = (props) => {
  if (isPrerender() || props.selectedLinkName) {
    return (
      <Suspense fallback={null}>
        <LazyImpl {...props} />
      </Suspense>
    );
  }
  return null;
};
